import React from "react";
import { Phone } from "lucide-react";
import { NAV } from "../../constants/testIds";
import { CONTACT } from "../../lib/site";

// Sticky bottom emergency bar on mobile only
export default function EmergencyBar() {
  return (
    <a
      href={`tel:${CONTACT.phoneTel}`}
      data-testid={`${NAV.emergencyCall}-sticky`}
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-forest text-paper flex items-center justify-center gap-3 py-3 text-[12px] tracking-[0.18em] uppercase shadow-paper"
    >
      <Phone size={14} strokeWidth={1.7} />
      Emergency · {CONTACT.phoneLabel}
    </a>
  );
}
